import { Component } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { FormApplicantService } from "../../service/form-applicant.service";
import { LoadingService } from "../../service/loading.service";
import { AccountLimitsService } from "../../service/account-limits.service";
import { Observable } from "rxjs";

@Component({
  selector: 'app-create-linked-profile-button',
  templateUrl: './create-linked-profile-button.component.html',
  styleUrls: ['./create-linked-profile-button.component.scss']
})
export class CreateLinkedProfileButtonComponent extends FieldType {
  restrictAccess$: Observable<boolean>;

  constructor(
    private formApplicantService: FormApplicantService,
    private accountLimitsService: AccountLimitsService,
    private loadingService: LoadingService) {
    super();
    this.restrictAccess$ = this.accountLimitsService.hasRestrictAccess();
  }


  onClickCreate() {
    const uuid = this.props['uuId'] as string;
    const sectionId = this.props['sectionId'] as number;
    this.loadingService.setLoading(true);
    this.formApplicantService.createApplicant({ sectionId }, uuid)
      .subscribe(response => {
        this.loadingService.setLoading(false);
        if (response.errors.length === 0) { // TODO we need to think about a global error handling for these cases
          const refreshCallback = this.props['refreshCallback'] as () => void;
          refreshCallback();
        }
      });
  }
}
